import AppService from "./AppService";

/**
 * ROOT_ADMIN per-organisation subscription management: view, assign/grant a
 * plan, manage discounts, and view billing history.
 */
class SubscriptionAdminService {
  getForOrg(orgId) {
    return AppService.get(`/api/admin/subscriptions/${orgId}`);
  }

  /** Per-org subscription summaries for the admin list (effective plan + expiry context). */
  getSummaries() {
    return AppService.get(`/api/admin/subscriptions/summary`);
  }

  assignPlan(orgId, data) {
    return AppService.post(`/api/admin/subscriptions/${orgId}/assign`, data);
  }

  getPayments(orgId) {
    return AppService.get(`/api/admin/subscriptions/${orgId}/payments`);
  }

  // Discounts
  listDiscounts(orgId) {
    return AppService.get(`/api/admin/subscriptions/${orgId}/discounts`);
  }

  createDiscount(orgId, data) {
    return AppService.post(`/api/admin/subscriptions/${orgId}/discounts`, data);
  }

  updateDiscount(discountId, data) {
    return AppService.put(`/api/admin/subscriptions/discounts/${discountId}`, data);
  }

  deleteDiscount(discountId) {
    return AppService.delete(`/api/admin/subscriptions/discounts/${discountId}`);
  }
}

const subscriptionAdminService = new SubscriptionAdminService();
export default subscriptionAdminService;
